import { createTheme } from "@material-ui/core/styles";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#5479FF",
        },
        secondary: {
            main: "#FF6C6C",
        },
    },

    typography: {
        fontFamily: "inherit",
        body1: {
            fontSize: 14,
        },
    },

    overrides: {
        typography: {
            fontFamily: "inherit",
            body1: {
                fontSize: 14,
            },
        },
        // MuiDataGrid, MuiMenuItem
        MuiDataGrid: {
            root: {
                fontFamily: "inherit",
                fontSize: 14,
            },
        },
    },
});
